module.exports = __webpack_public_path__ + "media/images/landing_page/4-47f71aca5a339f922c8fa964a91381fa.webp";